export const CREATE_OR_EDIT_STAMPS = {
  WITHOUT_RESTRICTIONS: null,
};
